<template>
  <v-app
    v-if="
      userIsAuthenticated &&
      $route.name !== 'Home' &&
      $route.name !== 'PageNotFound'
    "
  >
    <v-navigation-drawer app v-model="drawer">
      <v-list dense class="pt-0">
        <v-list-item class="py-1">
          <v-list-item-avatar>
            <ProfileImage />
          </v-list-item-avatar>
          <v-list-item-title class="body-2 font-weight-regular">
            {{ name }}
          </v-list-item-title>
          <span class="body-1">{{ cubeCount }}</span>
          <v-icon right>mdi-cube-outline</v-icon>
          <v-spacer />
        </v-list-item>
        <v-list-item
          :key="i"
          :to="item.link"
          @click="drawer = !drawer"
          link
          v-for="(item, i) in items"
        >
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ item.name }}
              {{
                item.name === 'Starred' && starredTodos.length >= 1
                  ? '(' + starredTodos.length + ')'
                  : ''
              }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="logout">
          <v-list-item-action>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title> Logout </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar app color="primary" dark min-width="350px">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title class="hidden-xs-only">
        {{ $route.name }}
      </v-toolbar-title>
      <v-spacer />
      <v-text-field
        v-if="['Completed', 'Starred', 'Dashboard'].includes($route.name)"
        solo-inverted
        hide-details
        flat
        prepend-inner-icon="mdi-magnify"
        placeholder="Search tasks"
        v-model="searchQuery"
      ></v-text-field>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="toggleDarkMode" icon v-on="on" v-bind="attrs">
            <v-icon>mdi-brightness-6</v-icon>
          </v-btn>
        </template>
        <span>Toggle dark-mode</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            @click="confirmDialog = true"
            icon
            v-on="on"
            v-bind="attrs"
            class="hidden-xs-only"
          >
            <v-icon>mdi-logout</v-icon>
          </v-btn>
        </template>
        <span>Logout</span>
      </v-tooltip>
      <ConfirmLogoutDialog
        :show-dialog="confirmDialog"
        @onClose="confirmDialog = false"
      ></ConfirmLogoutDialog>
    </v-app-bar>
    <v-main>
      <router-view :searchQuery="searchQuery" />
    </v-main>
    <Footer></Footer>
  </v-app>
  <v-app v-else>
    <router-view />
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import Footer from '@/components/Footer'
import ProfileImage from '@/components/ProfileImage'
import ConfirmLogoutDialog from '@/components/ConfirmLogoutDialog'

export default {
  name: 'App',
  components: {
    ConfirmLogoutDialog,
    ProfileImage,
    Footer,
  },
  data: () => ({
    dialog: false,
    drawer: false,
    confirmDialog: false,
    items: [
      {
        name: 'Dashboard',
        icon: 'mdi-home',
        link: '/dashboard',
      },
      {
        name: 'Starred',
        icon: 'mdi-star',
        link: '/starred',
      },
      {
        name: 'Completed',
        icon: 'mdi-check-decagram',
        link: '/completed',
      },

      {
        name: 'Deleted',
        icon: 'mdi-trash-can',
        link: '/deleted',
      },
      {
        name: 'Settings',
        icon: 'mdi-cog',
        link: '/settings',
      },
    ],
    searchQuery: '',
  }),
  computed: {
    ...mapGetters([
      'userIsAuthenticated',
      'starredTodos',
      'profileImageUrl',
      'name',
      'favoriteColor',
      'uid',
      'cubeCount',
    ]),
  },
  methods: {
    toggleDarkMode() {
      const firebase = require('./firebaseConfig.js')
      const darkMode = !this.$vuetify.theme.dark

      firebase.usersCollection
        .doc(this.uid)
        .update({ darkMode })
        .then(() => {
          this.$store.commit('SET_DARKMODE', darkMode)
          return this.$store.dispatch('fetchUserProfile')
        })
        .catch((err) => console.log(err))
    },
    logout() {
      this.$store.dispatch('firebaseLogout')
      this.$router.push('/')
    },
  },
}
</script>
